import * as Yup from "yup";
import FormikErrorMsgs from "../formikErrorMsgs";
import { useFormik } from "formik";
import AnimatedInput from "../AnimatedInput";
import { useState, useCallback } from "react";
import Image from "next/image";
import { apiBecomeAnAgentForm } from "./../../helpers/api";
import "react-phone-number-input/style.css";
import { useDropzone } from "react-dropzone";
import ReCAPTCHA from "reaptcha";

const Styles = {
  errorMsg: "text-red-primary text-sm"
};

const Spinner = () => (
  <Image src="/loading.png" width={20} height={20} alt="spinner" />
);
const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email(FormikErrorMsgs.invalidEmail)
    .required(FormikErrorMsgs.required),
  fullName: Yup.string().required(FormikErrorMsgs.required),
  linkedinLink: Yup.string().required(FormikErrorMsgs.required),
  ReCAPTCHA: Yup.string().required(FormikErrorMsgs.required)
});

const AgentFormHeader = () => (
  <div className="pb-12 md:pb-44 space-y-6 flex flex-col items-center lg:items-start justify-center ">
    <h1 className={"text-xl lg:text-5xl"}>Become an Agent</h1>

    <div className={"space-x-6"}>
      <p>
        Data Mynt Agents are compensated up to $10,000 per month to sell our
        products and onboard new customers while building trust and web3
        awareness with local businesses. Only onboarding Agents in Nigeria,
        Kenya, Mexico and Philippines currently.
      </p>
    </div>
  </div>
);

const AgentForm = ({ isPress = false }) => {
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [fileError, setFileError] = useState(false);
  const [base64Files, setBase64Files] = useState([]);
  const [recaptchaRef, setRecaptchaRef] = useState(null);

  const resetReCAPTCHA = () => {
    if (recaptchaRef) {
      recaptchaRef.reset();
    }
  };

  const onDrop = useCallback(acceptedFiles => {
    acceptedFiles.forEach(file => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setBase64Files(prevFiles => [...prevFiles, reader.result]);
        setFileError(false);
      };
      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
    });
  }, []);

  const { getRootProps, getInputProps, isDragActive, acceptedFiles } =
    useDropzone({ onDrop });

  const files = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const formik = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      linkedinLink: "",
      ReCAPTCHA: "",
      agentFile: ""
    },
    validateOnChange: false,

    onSubmit: async values => {
      let agentForm;
      if (base64Files.length === 0) {
        setFileError(true);
        return;
      }
      try {
        agentForm = await apiBecomeAnAgentForm({
          name: values.fullName,
          email: values.email,
          linkedIn: values.linkedinLink,
          captcha: values.ReCAPTCHA,
          agentFile: base64Files.join("|")
        });

        if (agentForm.status === 200) {
          setSuccess(true);
          setTimeout(() => {
            setSuccess(false);
            formik.resetForm();
            resetReCAPTCHA();
          }, 1900);
        }
      } catch (err) {
        setError(true);
        resetReCAPTCHA();
      }

      formik.resetForm();
      resetReCAPTCHA();
    },

    validationSchema,
    enableReinitialize: true
  });

  return (
    <div className="mapBg  ">
      <div className={"hidden lg:flex"}>
        <AgentFormHeader />
      </div>

      <form
        className="flex flex-col h-full justify-between bg-white rounded-lg lg:rounded-none lg:mb-0 lg:rounded-t-lg shadow-lg p-7 md:p-10 w-full max-w-2xl lg:justify-self-end mt-[30px]"
        name="agentForm"
        method="POST"
        onSubmit={formik.handleSubmit}
      >
        <h1 className="text-black text-[18px] md:text-[24px] font-bold ">
          Apply to become an Agent
        </h1>
        <input type="hidden" name="form-name" value="agentForm" />
        <AnimatedInput
          isPress
          value={formik.values.fullName}
          type="text"
          name="fullName"
          required
          onInputChange={formik.handleChange}
        >
          Full Name
        </AnimatedInput>
        <p className={formik.errors["fullName"] ? Styles.errorMsg : "hidden"}>
          {formik.errors["fullName"]}
        </p>
        <AnimatedInput
          isPress
          value={formik.values.email}
          type="text"
          name="email"
          required
          onInputChange={formik.handleChange}
        >
          Email address
        </AnimatedInput>
        <p className={formik.errors["email"] ? Styles.errorMsg : "hidden"}>
          {formik.errors["email"]}
        </p>
        <AnimatedInput
          isPress
          value={formik.values.linkedinLink}
          type="text"
          name="linkedinLink"
          required
          onInputChange={formik.handleChange}
        >
          Linkedin Link
        </AnimatedInput>
        <p
          className={formik.errors["linkedinLink"] ? Styles.errorMsg : "hidden"}
        >
          {formik.errors["linkedinLink"]}
        </p>
        <div>
          <p
            className={`${
              isPress ? "text-white" : "text-[#22242C]"
            } text-[16px] font-semibold   mb-[24px] mt-[32px]`}
          >
            Please attach your CV/Resume
          </p>
          <div
            {...getRootProps({ className: "dropzone" })}
            className="text-black box-border h-[160px] p-6 border-2 border-dashed rounded-lg text-center gap-[8px] border-[#191B1F66]"
          >
            <input {...getInputProps()} />
            <Image src="/document-upload.svg" width={20} height={20} alt="" />
            {base64Files.length > 0 ? (
              <p>
                <p className="text-[#191B1F66] mt-[8px] mb-[8px]">
                  File uploaded successfully
                </p>
                <p className="text-[#0051FE] text-[14px]   ">
                  Click here to change
                </p>
              </p>
            ) : (
              <>
                <p className="text-black text-[14px] text-[#27282F] font-[600px]">
                  Drag and Drop file Here
                </p>
                {isDragActive ? (
                  <p>Drop the files here ...</p>
                ) : (
                  <p>
                    <p className="text-[#191B1F66] mt-[8px] mb-[8px]">or</p>
                    <p className="text-[#0051FE] text-[14px]   ">Browse File</p>
                  </p>
                )}
              </>
            )}
          </div>
        </div>
        <p className={fileError ? Styles.errorMsg : "hidden"}>
          CV/Resume is required, with size not exceeding 5MBs.
        </p>
        <div className="flex flex-col space-y-2 items-center mt-4 -mb-6">
          <ReCAPTCHA
            value={formik.values.ReCAPTCHA}
            sitekey={
              process.env.NEXT_PUBLIC_CONTEXT === "production"
                ? process.env.NEXT_PUBLIC_RECAPTCHA_KEY
                : process.env.NEXT_PUBLIC_RECAPTCHA_TEST_KEY
            }
            onVerify={ReCAPTCHA => formik.setFieldValue("ReCAPTCHA", ReCAPTCHA)}
            ref={e => setRecaptchaRef(e)}
            onChange={() => resetReCAPTCHA(true)}
          />
          <p className={formik.errors["ReCAPTCHA"] ? Styles.errorMsg : ""}>
            {formik.errors["ReCAPTCHA"]}
          </p>
        </div>
        <div className="flex flex-col items-center justify-center mt-4">
          {formik.isSubmitting ? (
            <Spinner />
          ) : (
            <button
              type="submit"
              className={
                "bg-[#22242C] w-full px-8 py-2 text-white rounded-[38px] font-bold text-[16px] mt-[40px]"
              }
            >
              Submit your application
            </button>
          )}
          <p className={formik.errors["check"] ? Styles.errorMsg : ""}>
            {formik.errors["check"]}
          </p>
        </div>
        {success && (
          <p className="text-primary">
            Your info was sent successfully! We will get in touch shortly.
          </p>
        )}
        <p className="text-primary">{error.message}</p>
      </form>

      <div className={"flex lg:hidden"}>
        <AgentFormHeader />
      </div>
    </div>
  );
};

export default AgentForm;
